export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9463.6f8eb679.jpg";